import { render } from "./LuanLunPage.vue?vue&type=template&id=5fd1e5ad&scoped=true"
import script from "./LuanLunPage.vue?vue&type=script&lang=js"
export * from "./LuanLunPage.vue?vue&type=script&lang=js"

import "./LuanLunPage.vue?vue&type=style&index=0&id=5fd1e5ad&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5fd1e5ad"]])

export default __exports__